import { Map } from 'immutable';

export default pairs => pairs
    .reduce((current, [key, value]) => current.setIn(key.split('.'), value), Map());
